export class UserAllocationTotal {
    Total: number;
    Assigned: number;
}
